import { Vue, Component, Watch } from 'vue-property-decorator'
import { Getter, Mutation, Action } from 'vuex-class'

import * as LANGUAGES from '@/@next/store/languages/types'

import { Language, Scalars } from '@/@types/graphql'
import { forEach } from 'lodash'
import { LanguageCode } from '../@types'

@Component({ name: 'languages-mixin' })
export default class Languages extends Vue {

  @Getter(LANGUAGES.GET_ALL)
  _allLanguages!: Language[]
  @Getter(LANGUAGES.GET_CURRENT)
  _currentLanguage!: Scalars['String']
  @Getter(LANGUAGES.GET_USER_LANGUAGES)
  _userLanguages!: LanguageCode[]
  @Getter(LANGUAGES.GET_DEFAULT)
  _defaultLanguage!: Scalars['String']
  @Getter(LANGUAGES.GET_ALL_ISO)
  _allLanguageCodes!: Array<Scalars['String']>
  @Getter(LANGUAGES.GET_TARGET)
  _languageTarget!: Scalars['String']
  @Getter(LANGUAGES.GET_TRANSLATABLE_TARGETS)
  _translatableTargets!: any[]

  @Action(LANGUAGES.SET_ALL)
  _setAllLanguages!: (languages: Language[]) => void
  @Action(LANGUAGES.SET_CURRENT)
  _setCurrentLanguage!: (code: Scalars['String']) => void
  @Mutation(LANGUAGES.SET_DEFAULT)
  _setDefaultLanguage!: (code: Scalars['String']) => void
  @Mutation(LANGUAGES.SET_TARGET)
  _setTarget!: (code: Scalars['String'] | null) => void
  @Mutation(LANGUAGES.SET_TRANSLATABLE_TARGETS)
  _setTranslatableTarget!: (translatableTargets: any[]) => void

  @Watch('_currentLanguage')
  onCurrentLanguageChanged (iso: string) {
    const at = this.getAvailableTargetsForLanguage(iso)
    // if (!at.includes(this._languageTarget)) this._setTarget(null)
  }

  getAvailableTargetsForLanguage (iso: string | null = null) {
    const language = iso || this._currentLanguage
    return this._translatableTargets.filter((t: any) => t.languages.includes(language)).map((t: any) => t.target)
  }

  get availableTargets () {
    return this._translatableTargets
      .filter((t: any) => t.languages.includes(this._currentLanguage)).map((t: any) => t.target)
  }

  // get textSize ()  {
  //   return this.accessibility.textSize
  // }

  // get wordSpacing () {
  //   return this.accessibility.wordSpacing
  // }

  // get greyScale () {
  //   return this.accessibility.greyScale
  // }

  // get highContrast () {
  //   return this.accessibility.highContrast
  // }

  // get dyslexicFont () {
  //   return this.accessibility.dyslexicFont
  // }

  // get textToSpeech () {
  //   return this.accessibility.textToSpeech
  // }

  // get defaultCssValues () {
  //   return this.accessibility.defaultCssValues
  // }
  
  // setAccessibility (props: any) {
  //   this.storeAccessibility(props) 
  //   for (const [key, value] of Object.entries(props)) {
  //     switch (key) {
  //       case 'textSize': 
  //         document.body.style.fontSize = `${value as string}%`
  //         break;
  //       case 'wordSpacing': 
  //         document.body.style.wordSpacing = `${value as string}px`
  //         break;
  //       case 'greyScale': 
  //         document.body.style.filter = value ? 'grayscale(100%)' : 'none'
  //         break;
  //       case 'dyslexicFont': 
  //         this.setStyle('--sansSerifFontStack', 
  //           value ? 'OpenDyslexic' : this.defaultCssValues.sansSerifFontStack)
  //         this.setStyle('--serifFontStack', 
  //           value ? 'OpenDyslexic' : this.defaultCssValues.serifFontStack)
  //         break;
  //       case 'highContrast':
  //         const highContrast = value
  //         const backgroundContrastColor: string = '#fff'
  //         const onBackgroundContrastColor: string = '#000'
  //         this.setPrimaryColor()
  //         this.setOnPrimaryColor()
  //         this.setStyle('--onBackgroundColor', 
  //           highContrast ? backgroundContrastColor : this.defaultCssValues.onBackgroundColor)
  //         this.setStyle('--backgroundColor', 
  //           highContrast ? onBackgroundContrastColor : this.defaultCssValues.backgroundColor)
  //         // this.setStyle('--primaryColor', 
  //         //   highContrast ? backgroundContrastColor : this.defaultCssValues.primaryColor)
  //         // this.setStyle('--onPrimaryColor', 
  //         //   highContrast ? onBackgroundContrastColor : this.defaultCssValues.onPrimaryColor)
  //         this.setStyle('--foregroundColor', 
  //           highContrast ? onBackgroundContrastColor : this.defaultCssValues.foregroundColor)
  //         this.setStyle('--textOnForegroundColor', 
  //           highContrast ? backgroundContrastColor : this.defaultCssValues.textOnForegroundColor)
  //         this.setStyle('--menuBackgroundColor', 
  //           highContrast ? backgroundContrastColor : this.defaultCssValues.menuBackgroundColor)
  //         this.setStyle('--menuColor', 
  //           highContrast ? onBackgroundContrastColor : this.defaultCssValues.menuColor)
  //         this.setStyle('--cardTitleTextColor', 
  //           highContrast ? onBackgroundContrastColor : this.defaultCssValues.cardTitleTextColor)
  //         this.setStyle('--cardSummaryTextColor', 
  //           highContrast ? onBackgroundContrastColor : this.defaultCssValues.cardSummaryTextColor)
  //         this.setStyle('--cardTitleBackgroundColor', 
  //           highContrast ? backgroundContrastColor : this.defaultCssValues.cardTitleBackgroundColor)
  //         break;
  //       default:  break;
  //     }
  //   } 
  // }

  // scaleText (direction: string) {
  //   if (direction === 'up' && this.textSize < 140) this.setAccessibility({ textSize: this.textSize + 20 })
  //   if (direction === 'down' && this.textSize > 100) this.setAccessibility({ textSize: this.textSize - 20 })
  // }

  // scaleWordSpacing (direction: string) {
  //   if (direction === 'up' && this.wordSpacing < 10) this.setAccessibility({ wordSpacing: this.wordSpacing + 5 })
  //   if (direction === 'down' && this.wordSpacing > 0) this.setAccessibility({ wordSpacing: this.wordSpacing - 5 })
  // }

  // setGreyScale (value: boolean) {
  //   this.setAccessibility({ greyScale: value })
    
  // }

  // setDyslexicFont (dyslexicFont: boolean) {
  //   this.setAccessibility({ dyslexicFont })
    
  // }

  // setHighContrast (highContrast: boolean) {
  //   this.setAccessibility({ highContrast })  
  // }

  // setTextToSpeech (v: boolean) {
  //   this.setAccessibility({ textToSpeech: v }) 
  // }

  // setStyle (property: string, value: string) {
  //   const root = document.documentElement
  //   root.style.setProperty(property, value)
  // }

  // setCssProp (prop: string, value: string) {
  //   const root = document.documentElement
  //   if (!value?.length || !prop?.length) return
  //   root.style.setProperty(prop, value)
  // }

  // setPrimaryColor () {
  //   this.setCssProp(
  //     '--primaryColor', 
  //     this.accessibility.highContrast ? this.accessibility.defaultCssValues.backgroundContrastColor : 
  //     this.localStyle?.primaryColor ? this.localStyle?.primaryColor : 
  //     this.accessibility.defaultCssValues.primaryColor
  //   )
  // }

  // setOnPrimaryColor () {
  //   this.setCssProp(
  //     '--onPrimaryColor', 
  //     this.accessibility.highContrast ? this.accessibility.defaultCssValues.onBackgroundContrastColor : 
  //     this.localStyle?.onPrimaryColor ? this.localStyle?.onPrimaryColor : 
  //     this.accessibility.defaultCssValues.onPrimaryColor
  //   )
  // }

  // setLocalStyle (style: any | null) {
  //   console.log('setLocalStyle : ', style)
  //   this.storeLocalStyle(style || null)
  //   this.setPrimaryColor()
  //   this.setOnPrimaryColor()
  // }

}
